'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('global.errors');

  React.useEffect(() => {
    // Log the error to console
    console.error('Error caught by error boundary:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200 p-4">
      <div className="card w-full max-w-2xl bg-base-100 shadow-xl" role="alert">
        <div className="card-body">
          <h2 className="card-title text-error text-2xl">
            {t('UNCAUGHT_ERROR_TITLE')}
          </h2>

          <p className="text-base-content py-4">
            {t('UNCAUGHT_ERROR_DESCRIPTION')}
          </p>

          {error.digest && (
            <div className="text-sm text-base-content/60 mb-4">
              <span className="font-semibold">Error ID:</span> {error.digest}
            </div>
          )}

          <div className="card-actions flex flex-col sm:flex-row gap-2 justify-end">
            <a
              href="https://www.google.cn/intl/zh-CN/chrome/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost"
            >
              {t('DOWNLOAD_CHROME')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
